import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import UserTimeFormat from '../../../components/user-time-format/connected';
import UserDateFormat from '../../../components/user-date-format/index';

import { messages } from '../messages';
import style from './style.module.less';

const LabelCreatedMessage = () => <FormattedMessage {...messages.labelCreated} />;

const LabelCreated = ({ fulfillmentId }) => {
  const { shipDateTime } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  if (!shipDateTime) {
    return '';
  }

  return (
    <div className={style['label-created-column']}>
      <FormattedMessage {...messages.created} />
      <span className={style['label-created-date']}>
        <UserDateFormat value={shipDateTime} />
        <span>&bull;</span>
        <UserTimeFormat value={shipDateTime} />
      </span>
    </div>
  );
};

LabelCreated.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const labelCreated = {
  getMessageDescriptor: () => messages.labelCreated,
  name: <LabelCreatedMessage />,
  id: 'labelCreated',
  render: (data) => <LabelCreated fulfillmentId={data.id} />,
};
